import React, { useEffect, useState, useRef } from "react";
import {
    FormGroup,
    FormControlLabel,
    Checkbox,
    Typography,
    Grid,
    TextField,
    Box,
    Button,
    InputAdornment,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Tooltip,
    IconButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SendIcon from "@mui/icons-material/Send";
import axiosInstance from "../../../lib/axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import CustomAutocomplete from "../../AutoComplete/AutoComplete";
import checkAndLock from "../../../GlobalFunction/checkAndLock";
import UnLock from "../../../GlobalFunction/UnLock";
import CrudButtons from "../../../GlobalFunction/CrudButtons";
import { useReactToPrint } from "react-to-print";
import moment from "moment";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { enGB } from 'date-fns/locale';
import { format, isValid } from 'date-fns';
import PrintAdvice from "./PrintAdvice";
import SendAdviceLink from "./SendAdviceLink";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import CustomAutoCompleteNew from "../../AutoComplete/CustomAutoCompleteNew";
import { ConfirmDialog } from '../../ReusablePopup/CustomModel';
import AdviceLinkPopup from "./AdviceLinkPopup";
import axiosInstanceForPG from '../../../lib/axiosFormPG';
import {
    selectProperties,
    selectGlobalProperty,
    selectLocalProperty,
    setLocalProperty,
    fetchProperties,
    selectGatewayType
} from '../../../redux/propertySlice';
import { useSelector, useDispatch } from 'react-redux';

const CustomTextField = styled(TextField)(({ theme }) => ({
    "& .MuiFilledInput-root": {
        backgroundColor: "transparent",
        border: "1px solid #e0e0e0",
        borderRadius: "4px",
    },
    "& .Mui-focused": {
        borderColor: "#673ab7",
    },
    "& .MuiFilledInput-root.Mui-focused": {
        border: "1px solid #673ab7",
    },
}));

const initialFormData = {
    PropId: "",
    PytAdvFor: "O",
    PytAdvId: "",
    Amount: "",
    Remark: "",
    Status: "",
    RecDt: moment().format("DD/MM/YYYY"),
    BookDate: moment().format("DD/MM/YYYY"),
    MobileNo: "",
    ResidentName: "",
    PytAdvNo: "",
    BookNo: "",
    Email: "",
    PropName: "",
    BookId: "",
    ResidentId: "",
    BalAmount: "",
    BookPytAdvNo: "",
    RecId: "1",
    RecdtlId: "1",
    DueDt: moment().format("DD/MM/YYYY"),
    DueAmt: "",
    OthChrgId: "",
};

const AdviceForm = () => {
    const [formData, setFormData] = useState(initialFormData);
    const [error, setError] = useState({
        PropId: false,
        PytAdvFor: false,
        Amount: false,
        Remark: false,
        Status: false,
        MobileNo: false,
    });

    const navigate = useNavigate();
    const location = useLocation();
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [CurrrentPytAdvId, setCurrrentPytAdvId] = useState(null);
    const [mode, setMode] = useState("view");
    const [LastPytAdvId, setLastPytAdvId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [Propertydrp, setPropertydrp] = useState([]);
    const [OthChrgDrp, setOthChrgDrp] = useState([]);
    const [Status, setStatus] = useState("1");
    const [rows, setRows] = useState([]);
    const [openSendDialog, setOpenSendDialog] = useState(false);
    const [isRefOth, setIsRefOth] = useState(false);
    const [loading, setLoading] = useState(false);
    const [sendDialogVisible, setSendDialogVisible] = useState(false);
    const UserId = sessionStorage.getItem("UserId");
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({
        contentRef,
        documentTitle: `Advice No_${formData?.PytAdvNo || 'New'}`
    });
    const [selectedProperty, setSelectedProperty] = useState(null);
    const dispatch = useDispatch();
    const properties = useSelector(selectProperties);
    const globalProperty = useSelector(selectGlobalProperty);
    const localProperty = useSelector(state => selectLocalProperty(state, 'adviceForm'));
     const gatewayType = useSelector(selectGatewayType);

    useEffect(() => {
        dispatch(fetchProperties());
    }, [dispatch]);

    useEffect(() => {
        const propertyToUse = localProperty || globalProperty;
        if (propertyToUse && propertyToUse !== selectedProperty) {
            setSelectedProperty(propertyToUse);
            setFormData(prev => ({
                ...prev,
                PropId: propertyToUse.toString()
            }));
        }
    }, [localProperty, globalProperty]);

    const handlePropertyInputChange = (event, newValue) => {
        if (newValue) {
            const selectedId = newValue.Id.toString();
            setSelectedProperty(selectedId);

            setFormData(prev => ({
                ...prev,
                PropId: selectedId
            }));

            dispatch(setLocalProperty({
                componentId: 'adviceForm',
                propertyId: selectedId
            }));
        } else {
            setSelectedProperty(null);
            setFormData(prev => ({
                ...prev,
                PropId: ""
            }));
        }
    };

    const MstTopUpIdRef = useRef(null);
    const PropIdRef = useRef(null);
    const BookIdRef = useRef(null);
    const PytAdvIdRef = useRef(null);
    const PytAdvNoRef = useRef(null);
    const RemarkRef = useRef(null);

    const currentDate = format(new Date(), 'yyyy-MM-dd');
    const todayDate = new Date().toLocaleDateString()

    const baseUrl = window.location.origin;
    //   useEffect(() => {

    //     const urlParams = new URLSearchParams(window.location.search);
    //     const stateParam = urlParams.get('state');

    //     if (stateParam) {
    //         const state = JSON.parse(decodeURIComponent(stateParam));
    //         console.log('state 222', state);

    //         if (state && state.PytAdvId) {
    //             setCurrrentPytAdvId(state.PytAdvId);
    //             fetchAdviceForm(state.PytAdvId, "R");
    //             setMode("view");

    //             if (state.PropId) {
    //                 setFormData(prev => ({
    //                     ...prev,
    //                     PropId: state.PropId.toString()
    //                 }));
    //                 dispatch(setLocalProperty({
    //                     componentId: 'adviceForm',
    //                     propertyId: state.PropId.toString()
    //                 }));
    //             }
    //         }
    //     }
    //     else if (sessionStorage.getItem('adviceFormData')) {
    //         const state = JSON.parse(sessionStorage.getItem('adviceFormData'));
    //         if (state && state.PytAdvId) {
    //             setCurrrentPytAdvId(state.PytAdvId);
    //             fetchAdviceForm(state.PytAdvId, "R");
    //             setMode("view");

    //             if (state.PropId) {
    //                 setFormData(prev => ({
    //                     ...prev,
    //                     PropId: state.PropId.toString()
    //                 }));
    //                 dispatch(setLocalProperty({
    //                     componentId: 'adviceForm',
    //                     propertyId: state.PropId.toString()
    //                 }));
    //             }

    //             sessionStorage.removeItem('adviceFormData');
    //         }
    //     }
    //     else {
    //         setMode("add");
    //         setIsFormDisabled(false);
    //         setFormData((prev) => ({
    //             ...prev,
    //             RecDt: moment().format("DD/MM/YYYY"),
    //             BookDate: moment().format("DD/MM/YYYY"),
    //             DueDt: moment().format("DD/MM/YYYY"),
    //         }));
    //     }
    // }, [location, dispatch]);
    // In AdviceForm component
    useEffect(() => {
        // Check for data in URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const stateParam = urlParams.get('state');

        if (stateParam) {
            const state = JSON.parse(decodeURIComponent(stateParam));
            console.log('state 222', state)
            if (state && state.PytAdvId) {
                setCurrrentPytAdvId(state.PytAdvId);
                fetchAdviceForm(state.PytAdvId, "R");
                setMode("view");
            }
        }
        else if (sessionStorage.getItem('adviceFormData')) {
            const state = JSON.parse(sessionStorage.getItem('adviceFormData'));
            if (state && state.PytAdvId) {
                setCurrrentPytAdvId(state.PytAdvId);
                fetchAdviceForm(state.PytAdvId, "R");
                setMode("view");
                sessionStorage.removeItem('adviceFormData');
            }
        }
        else {
            setMode("add");
            setIsFormDisabled(false);
            setFormData((prev) => ({
                ...prev,
                RecDt: moment().format("DD/MM/YYYY"),
                BookDate: moment().format("DD/MM/YYYY"),
                DueDt: moment().format("DD/MM/YYYY"),
            }));
        }
    }, [location]);

    const handleMobileChange = (e) => {
        const val = e.target.value.trim();
        setFormData((prev) => ({ ...prev, MobileNo: val }));
        setError((prev) => ({ ...prev, MobileNo: val.length >= 10 ? false : prev.MobileNo }));

        if (val.length >= 10) {
            fetchBookingData(val);
        } else if (val.length < 10) {
            resetForm(val);
        }
    };

    const fetchBookingData = async (mobileNo) => {
        try {
            const response = await axiosInstance.post(`TrnBooking/GetTrnBookingDashBoard`, {
                start: 1,
                PageSize: 1,
                SearchText: '',
                Flag: '',
                MobileNo: mobileNo,
                BookNo: '',
                PropId: 1,
            });

            if (response.data.Status === 0 && response.data.Data?.length > 0) {
                const bookingData = response.data.Data[0];
                setFormData((prev) => ({
                    ...prev,
                    MobileNo: bookingData.MobileNo || "",
                    PropId: bookingData.PropId?.toString() || "",
                    PropName: bookingData.PropName || "",
                    ResidentName: bookingData.ResidentName || "",
                    BookNo: bookingData.BookNo || "",
                    Email: bookingData.Email || "",
                    Amount: bookingData.NetAmt?.toString() || "",
                    BookDate: bookingData.BookDt ? moment(bookingData.BookDt).format("DD/MM/YYYY") : "",
                    BookId: bookingData.BookId?.toString() || "",
                    ResidentId: bookingData.ResidentId?.toString() || "",
                    BalAmount: bookingData.NetAmt?.toString() || "",
                    DueAmt: bookingData.NetAmt?.toString() || "",
                }));
            } else {
                toast.info("No booking found for this mobile number");
                resetForm(mobileNo);
            }
        } catch (error) {
            console.error("Error fetching booking data:", error);
            toast.error("Error fetching booking data");
            resetForm(mobileNo);
        }
    };

    const fetchAdviceForm = async (id, flag) => {
        try {
            const response = await axiosInstance.post(`TrnBooking/RetriveTrnPytAdv`, {
                PytAdvId: parseInt(id.PytAdvId || id),
                BookId: 1,
                flag: flag,
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1 && response.data.Data?.length > 0) {
                const adviceData = response.data.Data[0];
                const apiPropId = adviceData.PropId?.toString() || "";
                setFormData({
                    PropId: apiPropId,
                    RecDt: adviceData.RecDt ? moment(adviceData.RecDt).format("DD/MM/YYYY") : moment().format("DD/MM/YYYY"),
                    BookDate: adviceData.BookDt ? moment(adviceData.BookDt).format("DD/MM/YYYY") : moment().format("DD/MM/YYYY"),
                    DueDt: adviceData.DueDt ? moment(adviceData.DueDt).format("DD/MM/YYYY") : moment().format("DD/MM/YYYY"),
                    PropId: adviceData.PropId?.toString() || "",
                    PytAdvFor: adviceData.PytAdvFor || "O",
                    PytAdvId: adviceData.PytAdvId?.toString() || "",
                    PytAdvNo: adviceData.PytAdvNo || "",
                    Amount: adviceData.Amount?.toString() || "",
                    Remark: adviceData.Remark || "",
                    Status: adviceData.Status?.toString() || "0",
                    MobileNo: adviceData.MobileNo || "",
                    ResidentName: adviceData.ResidentName || "",
                    BookNo: adviceData.BookNo || "",
                    Email: adviceData.Email || "",
                    PropName: adviceData.PropName || "",
                    BookId: adviceData.BookId?.toString() || "",
                    ResidentId: adviceData.ResidentId?.toString() || "",
                    BalAmount: adviceData.BalAmount?.toString() || "",
                    BookPytAdvNo: adviceData.BookPytAdvNo || "",
                    RecId: adviceData.RecId?.toString() || "1",
                    RecdtlId: adviceData.RecdtlId?.toString() || "1",
                    OthChrgId: adviceData.OthChrgId?.toString() || "",
                    ChrgName: adviceData.ChrgName || "",
                    DueAmt: adviceData.DueAmt?.toString() || "",
                });
                if (apiPropId) {
                    dispatch(setLocalProperty({
                        componentId: 'adviceForm',
                        propertyId: apiPropId
                    }));
                }
                setStatus(adviceData.Status?.toString() || "0");
                setIsFormDisabled(true);
                setCurrrentPytAdvId(adviceData.PytAdvId);
            } else {
                toast.success(response.data.Message || "No data found for the given PytAdvId");
                resetForm();
            }
        } catch (error) {
            toast.error("Error fetching Payment Advice data. Please try again.");
            resetForm();
        }
    };

    const resetForm = (mobileNo = "") => {
        setFormData({
            ...initialFormData,
            MobileNo: mobileNo,
        });
    };

    useEffect(() => {
        const fetchPropertyData = async () => {
            try {
                const response = await axiosInstance.post(`PropertyMst/GetPropertyMstUserwisedrp`, {
                    UserId,
                    Flag: "",
                });
                if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                    setPropertydrp(response.data.Data || []);
                    if (response.data.Data?.length > 0 && mode === "add") {
                        setFormData((prev) => ({
                            ...prev,
                            PropId: response.data.Data[0].Id.toString(),
                        }));
                    }
                } else {
                    toast.error("Failed to fetch Property");
                }
            } catch (error) {
                console.error("Error fetching Property:", error);
                toast.error("Error fetching Property.");
            }
        };
        fetchPropertyData();
    }, [UserId, mode]);

    const fetchOthCharges = async () => {
        setIsRefOth(true);
        try {
            const response = await axiosInstance.post(`MstOthChrg/GetMstOthChrgDrp`);
            if (response.data?.Data) {
                const mappedChargeData = response.data.Data.map((item) => ({
                    Id: item.OthChrgId,
                    Name: item.ChrgName,
                }));
                setOthChrgDrp(mappedChargeData);
            } else {
                toast.error("Failed to fetch Other Charges");
            }
        } catch (error) {
            console.error("Error fetching Other Charges:", error);
            toast.error("Error fetching Other Charges.");
        } finally {
            setTimeout(() => {
                setIsRefOth(false);
            }, 300);
        }
    };

    useEffect(() => {
        fetchOthCharges();
    }, []);

    useEffect(() => {
        const getRow = async () => {
            try {
                const res = await axiosInstance.post("TrnBooking/GetSelectTrnPytAdv", {
                    PytAdvDt: "2025-02-26",
                    Flag: "Dash",
                });
                if (res.data?.Data) {
                    setRows(res.data.Data);
                }
            } catch (err) {
                console.error("Error fetching dashboard data:", err);
                toast.error("Error while fetching data to print");
            }
        };
        getRow();
    }, []);

    const handlePrevious = async () => {
        if (CurrrentPytAdvId && CurrrentPytAdvId > 1) {
            await fetchAdviceForm({ PytAdvId: CurrrentPytAdvId }, "P");
        }
    };

    const handleNext = async () => {
        if (CurrrentPytAdvId) {
            await fetchAdviceForm({ PytAdvId: CurrrentPytAdvId }, "N");
        }
    };

    const handleInputChange = (event, newValue, name) => {
        if (newValue !== undefined && name) {
            setFormData((prev) => ({
                ...prev,
                [name]: newValue ? newValue.Id.toString() : "",
            }));
        } else {
            const { name, value } = event.target;
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            if (event.target === MstTopUpIdRef.current) {
                PropIdRef.current?.focus();
            } else if (event.target === PropIdRef.current) {
                BookIdRef.current?.focus();
            } else {
                PytAdvIdRef.current?.focus();
            }
        }
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
        setFormData((prev) => ({ ...prev, Status: updatedStatus }));
    };

    const handleSubmit = async () => {
        let hasError = false;

        if (!formData.MobileNo || formData.MobileNo.length < 10) {
            toast.error("Valid Mobile Number is required");
            setError((prev) => ({ ...prev, MobileNo: true }));
            hasError = true;
        }

        if (!formData.PropId) {
            toast.error("Property is required");
            setError((prev) => ({ ...prev, PropId: true }));
            hasError = true;
        }

        if (hasError) return;

        try {
            let response;
            if (mode === "edit") {
                if (!CurrrentPytAdvId) {
                    toast.error("Invalid payment advice ID");
                    return;
                }
                const payload = {
                    PytAdvId: parseInt(CurrrentPytAdvId),
                    PytAdvNo: formData.PytAdvNo || "",
                    PytAdvFor: formData.PytAdvFor || "O",
                    OthChrgId: parseInt(formData.OthChrgId) || 1,
                    Amount: parseFloat(formData.Amount) || 0,
                    Remark: formData.Remark || "",
                    Status: Status,
                    UpdatedBy: parseInt(UserId, 10) || 1,
                };
                response = await axiosInstance.post("TrnBooking/UpdateTrnPytAdv", payload);
            } else {
                const payload = {
                    PytAdvDt: formData.RecDt ? moment(formData.RecDt, "DD/MM/YYYY").format("YYYY-MM-DD") + "T00:00:00"
                        : moment().format("YYYY-MM-DD") + "T00:00:00",
                    PytAdvFor: formData.PytAdvFor || "O",
                    BookId: parseInt(formData.BookId) || 1,
                    ResidentId: parseInt(formData.ResidentId) || 1,
                    PropId: parseInt(formData.PropId) || 1,
                    OthChrgId: parseInt(formData.OthChrgId) || 1,
                    Amount: parseFloat(formData.Amount) || 0,
                    BalAmount: parseFloat(formData.BalAmount) || parseFloat(formData.Amount) || 0,
                    BookPytAdvNo: formData.BookPytAdvNo || "",
                    RecId: parseInt(formData.RecId) || 1,
                    RecdtlId: parseInt(formData.RecdtlId) || 1,
                    RecDt: formData.RecDt ? moment(formData.RecDt, "DD/MM/YYYY").format("YYYY-MM-DD") + "T00:00:00"
                        : moment().format("YYYY-MM-DD") + "T00:00:00",
                    RcdAmt: parseFloat(formData.Amount) || 0,
                    DueDt: formData.DueDt ? moment(formData.DueDt, "DD/MM/YYYY").format("YYYY-MM-DD") + "T00:00:00"
                        : moment().format("YYYY-MM-DD") + "T00:00:00",
                    DueAmt: parseFloat(formData.DueAmt) || parseFloat(formData.Amount) || 0,
                    Remark: formData.Remark || "",
                    Status: Status,
                    CreatedBy: parseInt(UserId, 10) || 1,
                };
                response = await axiosInstance.post("TrnBooking/InsertTrnPytAdv", payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                if (mode === "edit") {
                    toast.success("Data updated successfully");
                    await fetchAdviceForm({ PytAdvId: CurrrentPytAdvId }, "R");
                    setMode("view");
                    setIsFormDisabled(true);
                    setSendDialogVisible(true);
                } else {
                    toast.success("Data inserted successfully");
                    setLastPytAdvId(response.data.Data);
                    await fetchAdviceForm({ PytAdvId: response.data.Data }, "R");
                    setMode("view");
                    setIsFormDisabled(true);
                    setCurrrentPytAdvId(response.data.Data);
                    setSendDialogVisible(true);
                }
            } else {
                toast.error(response.data.Message || "Operation failed");
            }
        } catch (error) {
            toast.error(error.response?.data?.Message || "Error updating payment advice. Please try again.");
        }
    };

    const handleEdit = async () => {
        if (formData.Amount !== formData.BalAmount) {
            return toast.error('Balanced Amount has been changed Can not edit !')
        }
        let Flag = await checkAndLock(CurrrentPytAdvId, "TrnBooking", "PytAdvId");
        switch (Flag) {
            case 0:
                setMode("edit");
                setIsFormDisabled(false);
                break;
            case 1:
                toast.info("Record Already Locked", { autoClose: 500 });
                break;
            case 2:
                toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default:
                toast.info("Something Went Wrong", { autoClose: 500 });
        }
    };

    const handleAdd = () => {
        setMode("add");
        setIsFormDisabled(false);
        setFormData({
            ...initialFormData,
            OthChrgId: OthChrgDrp.length > 0 ? OthChrgDrp[0].Id.toString() : "",
        });
        setStatus("1");
        setCurrrentPytAdvId(null);
    };

    const handleCancel = async () => {
        try {
            await fetchAdviceForm(1, "L");
            await UnLock(CurrrentPytAdvId, "TrnBooking", "PytAdvId");
            setStatus("1");
            setMode("view");
            setIsFormDisabled(true);
        } catch (error) {
            console.error("Error during cancel:", error);
            toast.error("Error occurred while cancelling. Please try again.");
        }
    };

    const handleExit = () => {
        navigate("/advicegeneratetable");
    };

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const openOth = () => {
        window.open("/othercharges");
    }

    const handleConfirmDelete = async () => {
        let Flag = await checkAndLock(CurrrentPytAdvId, "TrnBooking", "PytAdvId");
        switch (Flag) {
            case 0:
                setOpenConfirmDialog(false);
                await fetchAdviceForm({ PytAdvId: CurrrentPytAdvId }, "D");
                await fetchAdviceForm(1, "N");
                setMode("view");
                setIsFormDisabled(true);
                break;
            case 1:
                toast.info("Record Already Locked", { autoClose: 500 });
                break;
            case 2:
                toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default:
                toast.info("Something Went Wrong", { autoClose: 500 });
        }
    };

    const handleSendAdviceEmail = () => {
        if (!formData.Email) {
            toast.error("Email address is required to send the payment advice.");
            return;
        }
        if (!formData.PytAdvNo) {
            toast.error("Payment Advice Number is required to send the email.");
            return;
        }
        setOpenSendDialog(true);
    };

    const generatePDFContent = () => {
        try {
            const doc = new jsPDF();
            let yPos = 20;
            const pageWidth = doc.internal.pageSize.width;
            const margin = 20;

            doc.setTextColor(99, 91, 255);
            doc.setFontSize(25);
            doc.text(formData.PropName || "No Property Name Available", pageWidth / 2, yPos, { align: "center" });

            yPos += 10;
            doc.setFontSize(18);
            doc.setTextColor(0);
            doc.text("Payment Advice", pageWidth / 2, yPos, { align: "center" });

            doc.autoTable({
                startY: yPos + 5,
                head: [[{ content: "Payment Advice Summary", colSpan: 4, styles: { halign: "left", fillColor: [99, 91, 255], textColor: 255, fontSize: 14, cellPadding: 3 } }]],
                body: [
                    [
                        { content: "Advice No", styles: { fontStyle: "bold" } },
                        formData.PytAdvNo || "",
                        { content: "Advice Date", styles: { fontStyle: "bold" } },
                        formData.RecDt ? moment(formData.RecDt, "DD/MM/YYYY").format("DD-MM-YYYY") : "",
                    ],
                    [
                        { content: "Resident Name", styles: { fontStyle: "bold" } },
                        formData.ResidentName || "",
                        { content: "Mobile No", styles: { fontStyle: "bold" } },
                        formData.MobileNo || "",
                    ],
                    [
                        { content: "Email", styles: { fontStyle: "bold" } },
                        formData.Email || "",
                        { content: "Booking No", styles: { fontStyle: "bold" } },
                        formData.BookNo || "",
                    ],
                    [
                        { content: "Amount", styles: { fontStyle: "bold" } },
                        formData.Amount || "",
                    ],
                ],
                theme: "grid",
                styles: {
                    fontSize: 10,
                    cellPadding: 3,
                    lineColor: [229, 231, 235],
                    lineWidth: 0.1,
                },
                alternateRowStyles: {
                    fillColor: [249, 250, 251],
                },
                margin: { left: margin, right: margin },
            });

            yPos = doc.lastAutoTable.finalY + 15;
            doc.setFontSize(16);
            doc.setTextColor(99, 91, 255);
            doc.text("Details", margin, yPos);

            doc.autoTable({
                startY: yPos + 5,
                head: [["Book No", "Book Date", "Amount", "Remark"]],
                body: [
                    [
                        formData.BookNo || "",
                        formData.BookDate ? moment(formData.BookDate, "DD/MM/YYYY").format("DD-MM-YYYY") : "",
                        formatValue(formData.Amount),
                        formData.Remark || "",
                    ],
                ],
                theme: "grid",
                styles: {
                    fontSize: 10,
                    cellPadding: 3,
                    lineColor: [229, 231, 235],
                    lineWidth: 0.1,
                },
                alternateRowStyles: {
                    fillColor: [249, 250, 251],
                },
                margin: { left: margin, right: margin },
            });

            yPos = doc.lastAutoTable.finalY + 15;
            doc.setFontSize(12);
            doc.setTextColor(0);
            doc.text("Thank you for choosing Clanbridge Living Pvt Ltd", margin, yPos);
            doc.text("For any queries, please contact: support@clanbridgeliving.in", margin, yPos + 5);

            return doc;
        } catch (error) {
            return null;
        }
    };

    const formatValue = (value) => {
        if (typeof value === "number") {
            return value.toFixed(2);
        }
        if (value && moment(value, moment.ISO_8601, true).isValid()) {
            return moment(value).format("DD-MM-YYYY");
        }
        return value || "";
    };

    const handleSendEmail = async (emailData) => {
    if (!formData.ResidentId || !formData.PytAdvNo) {
        toast.error("Resident information or advice number not available");
        return;
    }

    const { toEmails, subject, body } = emailData;

    if (!toEmails || toEmails.length === 0) {
        toast.error("No valid email addresses provided to send the payment advice.");
        return;
    }

    try {
        setLoading(true);

        const doc = generatePDFContent();
        if (!doc) {
            toast.error("Failed to generate PDF document");
            return;
        }

        const pdfData = doc.output('blob');
        const reader = new FileReader();
        const pdfBase64 = await new Promise((resolve, reject) => {
            reader.onload = () => resolve(reader.result.split(',')[1]);
            reader.onerror = reject;
            reader.readAsDataURL(pdfData);
        });

        const pdfDataUri = `data:application/pdf;base64,${pdfBase64}`;
        const pytAdvNo = formData.PytAdvNo;
        console.log('formDatae', formData);
        
        
        // const gatewayType = gatewayType || 'CashFree';
        let paymentResponse = null;

       
        if (gatewayType === 'CashFree') {
            const paymentDetails = {
                customer_details: {
                    customer_email: formData.Email || "",
                    customer_name: formData.ResidentName,
                    customer_phone: formData.MobileNo || ""
                },
                link_amount: parseFloat(formData.Amount) || 0,
                link_auto_reminders: true,
                link_currency: "INR",
                link_expiry_time: "2026-06-09T15:04:05+05:30",
                link_id: `Testing9062026`,
                link_meta: {
                    notify_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
                    return_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
                    upi_intent: false
                },
                link_minimum_partial_amount: parseFloat(formData.Amount) || 0,
                link_notes: {
                    key_1: "CashFreepay",
                    key_2: "linkCashfree"
                },
                link_notify: {
                    send_email: true,
                    send_sms: true
                },
                link_partial_payments: true,
                link_purpose: `${formData.ChrgName},# ${formData.PytAdvNo}`,
                ResidentId: formData.ResidentId,
                Flag: "Active",
                Remark: "Testing",
                TrjType: "TrnPytAdv",
                TrjDocNo: formData.PytAdvNo,
                TrjDocId: formData.PytAdvId,
                cf_payment_id: "",
                payment_status: "",
                PropId: formData.PropId,
            };

            const responsedata = await axiosInstanceForPG.post(
                `PaymentGatewayLog/CreateCashFreeLink`,
                paymentDetails,
            );
            
            if (responsedata.data.Status == 0) {
                setLoading(false);
                setOpenSendDialog(false);
                setSendDialogVisible(false);
                return toast.success(responsedata.data.Message);
            }

            paymentResponse = responsedata.data;
            if (typeof paymentResponse === 'string') {
                paymentResponse = JSON.parse(paymentResponse);
            }

            if (!paymentResponse || !paymentResponse.link_url) {
                console.error("Invalid payment response:", paymentResponse);
                toast.error("Failed to create payment link");
                setLoading(false);
                setOpenSendDialog(false);
                setSendDialogVisible(false);
                return;
            }

        } else if (gatewayType === 'Instamojo') {
            const paymentDetails = {
                purpose: `${formData.ChrgName},# ${formData.PytAdvNo}`,
                amount: parseFloat(formData.Amount) || 0,
                buyer_name: formData.ResidentName || '',
                email: formData.Email || '',
                phone: formData.MobileNo || '',
                redirect_url: `${baseUrl}/payment-success`,
                redirecturl: `${baseUrl}/payment-success/`,
                webhook_url: '',
                ResidentId: formData.ResidentId,
                TrjDocId: formData.PytAdvId || 0,
                TrjType: "TrnPytAdv",
                TrjDocNo: formData.PytAdvNo || '',
                PropId: formData.PropId || 0,
            };

            const responsedata = await axiosInstanceForPG.post(
                `Payment/CreatePaymentOrder`,
                paymentDetails,
            );

            if (responsedata.data.Status === 0) {
                setLoading(false);
                setOpenSendDialog(false);
                setSendDialogVisible(false);
                return toast.success(responsedata.data.Message);
            }

            paymentResponse = JSON.parse(responsedata.data);

            if (!paymentResponse || !paymentResponse.payment_request || !paymentResponse.payment_request.longurl) {
                console.error("Invalid payment response:", paymentResponse);
                toast.error("Failed to create payment link");
                setLoading(false);
                setOpenSendDialog(false);
                setSendDialogVisible(false);
                return;
            }

        } else {
            toast.error(`Unsupported gateway type: ${gatewayType}`);
            setLoading(false);
            setOpenSendDialog(false);
            setSendDialogVisible(false);
            return;
        }

        
        const paymentToken = gatewayType === 'CashFree' ? paymentResponse.link_id : paymentResponse.payment_request.id;
        const paymentUrl = gatewayType === 'CashFree' ? paymentResponse.link_url : paymentResponse.payment_request.longurl;
        const intermediatePageUrl = `${baseUrl}/paymentpage?token=${paymentToken}`;

        let paymentLogPayload;
        if (gatewayType === 'CashFree') {
            paymentLogPayload = {
                id: paymentResponse.link_id,
                cf_link_id: paymentResponse.cf_link_id,
                phone: paymentResponse.customer_details.customer_phone,
                email: paymentResponse.customer_details.customer_email,
                buyer_name: paymentResponse.customer_details.customer_name || 'null',
                amount: paymentResponse.link_amount,
                purpose: paymentResponse.link_purpose,
                expires_at: null,
                status: paymentResponse.link_status,
                send_sms: paymentResponse.link_notify.send_sms,
                send_email: paymentResponse.link_notify.send_email,
                sms_status: 'null',
                email_status: 'null',
                shorturl: 'null',
                longurl: paymentResponse.link_url,
                redirect_url: paymentResponse.link_meta.return_url,
                webhook: 'null',
                allow_repeated_payments: true,
                created_at: paymentResponse.link_created_at,
                modified_at: paymentResponse.link_created_at,
                link_qrcode: paymentResponse.link_qrcode,
                ResidentId: formData.ResidentId,
                TrjDocNo: formData.PytAdvNo,
                TrjDocId: formData.PytAdvId,
                TrjType: "TrnPytAdv",
                Flag: "Active",
                Remark: "Payment Link for Payment Advice",
                Gatewaytype: "CashFree",
            };
        } else {
            paymentLogPayload = {
                id: paymentResponse.payment_request.id,
                phone: paymentResponse.payment_request.phone,
                email: paymentResponse.payment_request.email,
                buyer_name: paymentResponse.payment_request.buyer_name,
                amount: paymentResponse.payment_request.amount,
                purpose: paymentResponse.payment_request.purpose,
                expires_at: paymentResponse.payment_request.expires_at,
                status: paymentResponse.payment_request.status,
                send_sms: paymentResponse.payment_request.send_sms,
                send_email: paymentResponse.payment_request.send_email,
                sms_status: paymentResponse.payment_request.sms_status,
                email_status: paymentResponse.payment_request.email_status,
                shorturl: paymentResponse.payment_request.shorturl,
                longurl: paymentResponse.payment_request.longurl,
                redirect_url: paymentResponse.payment_request.redirect_url,
                webhook: paymentResponse.payment_request.webhook,
                allow_repeated_payments: paymentResponse.payment_request.allow_repeated_payments,
                created_at: paymentResponse.payment_request.created_at,
                modified_at: paymentResponse.payment_request.modified_at,
                ResidentId: formData.ResidentId,
                TrjDocNo: formData.PytAdvNo,
                TrjDocId: formData.PytAdvId,
                TrjType: "TrnPytAdv",
                Flag: "Active",
                Remark: "Payment Link for Payment Advice",
                Gatewaytype: "Instamojo",
            };
        }

        await axiosInstance.post('PaymentGatewayLog/InsertPaymentRequestLog', paymentLogPayload);

        const emailPayload = {
            PropId: parseInt(formData.PropId) || 1,
            UserId: parseInt(UserId) || 1,
            ToEmail: toEmails,
            Subject: `Clanbridge Living - Payment Request For Payment Advice No - ${pytAdvNo}`,
            ImgFolderNm: pytAdvNo,
            Body: `Hey <strong>${formData.ResidentName}</strong>,<br><br>
         We would like to inform you that payment advice has been created for you tenancy at <strong>${formData.PropName}</strong>. Please find attached your payment advice with this email.<br><br>
         Following are the details : <br><br>
          Purpose: <strong>${formData.ChrgName}</strong><br>
          Advice No: <strong>${formData.PytAdvNo}</strong><br>
          Amount: <strong>${formData.Amount}</strong><br>
          Date Of Issue: <strong>${todayDate}</strong><br>
        Due Date: <strong>${(formData.DueDt)}</strong><br>
        <strong>Payment Link:</strong> <a href="${intermediatePageUrl}" target="_blank" style="background-color: #1b29a7ff; color: white; padding: 4px 10px; text-decoration: none; border-radius: 4px; display: inline-block; margin-top: 5px;">Pay Now</a><br><br>
    We hope you are having a pleasant stay with us. Do let us know if you need any assistance. You may contact us at <strong>sales@clanbridge.com</strong> or reach out to Your Resident Captains.<br>
    Cheers,<br>
    Team Clanbridge`,
            DocAttachments: [
                {
                    FileName: `Payment_Advice_${pytAdvNo}.pdf`,
                    FileContent: pdfDataUri,
                },
            ],
            TblName: 'TrnPytAdv',
            Id: formData.PytAdvId,
        };

        console.log("Email Payload:", JSON.stringify(emailPayload, null, 2));

        const response = await axiosInstance.post("EmailRequest/SendEmail", emailPayload);
        if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
            toast.success(response.data.Message || "Email sent successfully!");
        } else {
            toast.error(response.data.Message || "Failed to send email");
        }
    } catch (error) {
        console.error('Error in handleSendEmail:', error);
        toast.error(error.response?.data?.Message || "Failed to send email. Please try again.");
    } finally {
        setLoading(false);
        setOpenSendDialog(false);
        setSendDialogVisible(false);
    }
};

    const buttonSx = {
        backgroundColor: "#635bff",
        borderRadius: "5px",
        padding: "5px",
        margin: { xs: "0px 5px", sm: "0px 5px" },
        "&:hover": {
            backgroundColor: "#1565c0",
            cursor: "pointer",
        },
        minWidth: { xs: "40px", sm: "40px", md: "60px" },
        "&:disabled": {
            backgroundColor: "rgba(0, 0, 0, 0.12)",
            color: "rgba(0, 0, 0, 0.26)",
            boxShadow: "none",
        },
    };

    return (
        <>
            <Box className="form-container" sx={{ height: { xs: "700px", sm: "550px" } }}>
                <ToastContainer />
                <Grid container spacing={2} className="form_grid">
                    <Grid
                        item
                        xs={12}
                        className="form_title"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginTop: "20px",
                            flexDirection: { xs: "column", sm: "row", md: "row" },
                        }}
                    >
                        <Grid
                            sx={{
                                display: "flex",
                                justifyContent: { xs: "center", sm: "flex-start" },
                                marginBottom: { xs: "10px", sm: 0 },
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-previous"
                                onClick={handlePrevious}
                                sx={{
                                    backgroundColor: "#635BFF",
                                    marginRight: { xs: "5px", sm: "8px" },
                                }}
                                disabled={mode !== "view" || !CurrrentPytAdvId || CurrrentPytAdvId === 1}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-next"
                                onClick={handleNext}
                                sx={{
                                    backgroundColor: "#635BFF",
                                }}
                                disabled={mode !== "view" || !CurrrentPytAdvId}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>
                        <Typography
                            variant="h5"
                            sx={{
                                margin: "auto",
                                textAlign: { xs: "center", sm: "center" },
                                fontSize: { xs: "24px", sm: "18px", md: "24px" },
                            }}
                        >
                            Payment Advice
                        </Typography>
                        <Tooltip title="Send Mail" arrow>
                            <IconButton onClick={handleSendAdviceEmail} sx={buttonSx} disabled={loading || mode !== "view"}>
                                <SendIcon sx={{ color: "white" }} />
                            </IconButton>
                        </Tooltip>
                        <Grid sx={{ display: "flex", justifyContent: "end" }}>
                            <CrudButtons
                                moduleName="Payment Advice"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleDeleteClick}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_field">
                        <Grid container spacing={2} justifyContent="center">
                            <Grid item xs={12} md={6} lg={3.5} className="form_field">
                                <CustomAutocomplete
                                    options={properties}
                                    id="PropId-autocomplete"
                                    name="PropId"
                                    label={<span>Property<span style={{ color: "red" }}>*</span></span>}
                                    value={properties.find((prop) => prop.Id == selectedProperty) || null}
                                    onChange={handlePropertyInputChange}
                                    disabled={isFormDisabled}
                                    error={error.PropId}
                                    helperText={error.PropId ? "Property is required" : ""}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={2.5} className="form_field">
                                <CustomAutoCompleteNew
                                    options={OthChrgDrp}
                                    id="OthChrgId-autocomplete"
                                    name="OthChrgId"
                                    label={<span>Other Charges</span>}
                                    value={OthChrgDrp.find((OthChg) => OthChg.Id === parseInt(formData.OthChrgId)) || null}
                                    onChange={(e, newValue) => handleInputChange(e, newValue, "OthChrgId")}
                                    disabled={isFormDisabled}
                                    onAddClick={openOth}
                                    onRefreshClick={fetchOthCharges}
                                    isRefreshing={isRefOth}
                                    shrink={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={2} className="form_field">
                                <TextField
                                    id="PytAdvNo"
                                    name="PytAdvNo"
                                    label="Advice No"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.PytAdvNo}
                                    onChange={handleInputChange}
                                    disabled={true}
                                    inputRef={PytAdvNoRef}
                                    onKeyDown={handleKeyPress}
                                    InputProps={{ readOnly: true }}
                                    InputLabelProps={{ shrink: !!formData.PytAdvNo }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={2} className="form_field">
                                <TextField
                                    id="PytAdvId"
                                    name="PytAdvId"
                                    label="Advice Id"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.PytAdvId}
                                    onChange={handleInputChange}
                                    disabled={true}
                                    inputRef={PytAdvIdRef}
                                    onKeyDown={handleKeyPress}
                                    InputProps={{ readOnly: true }}
                                    InputLabelProps={{ shrink: !!formData.PytAdvId }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={2} className="form_field">
                                <LocalizationProvider dateAdapter={AdapterDateFns} locale={enGB}>
                                    <DatePicker
                                        label="Advice Date"
                                        value={formData.RecDt ? new Date(moment(formData.RecDt, "DD/MM/YYYY").format("YYYY-MM-DD")) : new Date()}
                                        onChange={(newValue) => {
                                            setFormData((prev) => ({
                                                ...prev,
                                                RecDt: newValue && isValid(newValue) ? format(newValue, 'dd/MM/yyyy') : '',
                                            }));
                                        }}
                                        disabled={isFormDisabled}
                                        views={['day', 'month', 'year']}
                                        openTo="day"
                                        format="dd/MM/yyyy"
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                variant: "filled",
                                                className: "custom-textfield",
                                                InputLabelProps: { shrink: true },
                                                inputProps: { max: currentDate },
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_field">
                        <Grid container spacing={2} justifyContent="center">
                            <Grid item xs={12} md={6} lg={4} className="form_field">
                                <TextField
                                    id="MobileNo"
                                    name="MobileNo"
                                    label={<span>Mobile No<span style={{ color: "red" }}>*</span></span>}
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.MobileNo}
                                    onChange={handleMobileChange}
                                    disabled={isFormDisabled}
                                    error={error.MobileNo}
                                    helperText={error.MobileNo ? "Valid mobile number is required" : ""}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={4} className="form_field">
                                <TextField
                                    id="ResidentName"
                                    name="ResidentName"
                                    label="Resident Name"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.ResidentName}
                                    onChange={handleInputChange}
                                    disabled={true}
                                    InputProps={{ readOnly: true }}
                                    InputLabelProps={{ shrink: !!formData.ResidentName }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={2} className="form_field">
                                <TextField
                                    id="BookNo"
                                    name="BookNo"
                                    label="Book No"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.BookNo}
                                    onChange={handleInputChange}
                                    disabled={true}
                                    InputProps={{ readOnly: true }}
                                    InputLabelProps={{ shrink: !!formData.BookNo }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={2} className="form_field">
                                <LocalizationProvider dateAdapter={AdapterDateFns} locale={enGB}>
                                    <DatePicker
                                        label="Book Date"
                                        value={formData.BookDate ? new Date(moment(formData.BookDate, "DD/MM/YYYY").format("YYYY-MM-DD")) : new Date()}
                                        onChange={(newValue) => {
                                            setFormData((prev) => ({
                                                ...prev,
                                                BookDate: newValue && isValid(newValue) ? format(newValue, 'dd/MM/yyyy') : '',
                                            }));
                                        }}
                                        disabled={isFormDisabled}
                                        views={['day', 'month', 'year']}
                                        openTo="day"
                                        format="dd/MM/yyyy"
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                variant: "filled",
                                                className: "custom-textfield",
                                                InputLabelProps: { shrink: true },
                                                inputProps: { max: currentDate },
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_field">
                        <Grid container spacing={2} justifyContent="center">
                            <Grid item xs={12} md={6} lg={2} className="form_field">
                                <TextField
                                    id="Amount"
                                    name="Amount"
                                    label="Advice Amount"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Amount}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    InputLabelProps={{ shrink: !!formData.Amount }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={2} className="form_field">
                                <TextField
                                    id="PytAdvFor"
                                    name="PytAdvFor"
                                    label="Payment Advice For"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.PytAdvFor}
                                    onChange={handleInputChange}
                                    disabled={true}
                                    inputRef={BookIdRef}
                                    onKeyDown={handleKeyPress}
                                    InputProps={{ readOnly: true }}
                                    InputLabelProps={{ shrink: !!formData.PytAdvFor }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={4} className="form_field">
                                <TextField
                                    id="Email"
                                    name="Email"
                                    label="Email"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Email}
                                    onChange={handleInputChange}
                                    disabled={true}
                                    InputProps={{ readOnly: true }}
                                    InputLabelProps={{ shrink: !!formData.Email }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={4} className="form_field">
                                <TextField
                                    id="Remark"
                                    name="Remark"
                                    label="Remark"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Remark}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={RemarkRef}
                                    onKeyDown={handleKeyPress}
                                    InputLabelProps={{ shrink: !!formData.Remark }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        <Grid item xs={12} md={6} lg={1}>
                            <FormGroup>
                                <FormControlLabel
                                    control={<Checkbox disabled={isFormDisabled} checked={Status === "1"} onChange={handleChangeStatus} />}
                                    label="Status"
                                />
                            </FormGroup>
                        </Grid>
                        {mode === "view" && (
                            <>
                                <Button
                                    variant="contained"
                                    sx={{ mr: 1, background: "linear-gradient(290deg, #d4d4d4, #d4d4d4)" }}
                                    onClick={handleAdd}
                                    disabled
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{ mr: 1, background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)" }}
                                    onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === "edit" || mode === "add") && (
                            <>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: "none" }}>
                <PrintAdvice
                    contentRef={contentRef}
                    formData={formData}
                    PytAdvId={CurrrentPytAdvId}
                    shouldFetchData={!!CurrrentPytAdvId}
                    key={CurrrentPytAdvId}
                />
            </div>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: "#635bff",
                            color: "white",
                            "&:hover": { backgroundColor: "#1565c0", color: "white" },
                        }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: "#635bff",
                            color: "white",
                            "&:hover": { backgroundColor: "#1565c0", color: "white" },
                        }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>

            <SendAdviceLink
                open={openSendDialog}
                onClose={() => setOpenSendDialog(false)}
                onSend={handleSendEmail}
                initialEmail={formData.Email}
                residentName={formData.ResidentName}
            />

            <AdviceLinkPopup
                open={sendDialogVisible}
                onClose={() => setSendDialogVisible(false)}
                onSend={handleSendEmail}
                initialEmail={formData.Email}
                residentName={formData.ResidentName}
                hideContent={true}
                showContent={false}
            />
        </>
    );
};

export default AdviceForm;